module.exports = __webpack_public_path__ + "static/images/tag-hollow.4ee3a04a92d9aae21b9ed1cfb82696ea.svg";